import { makeStyles } from '@mui/styles';

const getCellSize = (percentage: number) => {
  return `calc(100% * ${percentage / 100})`;
};

export const useTableRowStyles = makeStyles((theme) => ({
  cell: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px 12px',
  },

  currencyCell: {
    minWidth: '80px',
    width: '80px',
    paddingLeft: '16px',
  },

  providerIdCell: {
    width: '120px',
  },

  providerCompositeScoreCell: {
    width: '120px',
    justifyContent: 'space-around',
  },

  amountCell: {
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(12),
    },
  },

  nominalInterestCell: {
    width: '90px',
  },

  riskCell: {
    minWidth: '100px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  defaultRateCell: {
    width: '100px',
  },

  productTypeCell: {
    minWidth: '140px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(12),
    },
  },

  durationCell: {
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  irrCell: {
    minWidth: '100px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(12),
    },
  },

  dealSizeCell: {
    minWidth: '200px',
  },

  inputCell: {
    maxWidth: '236px',
    minWidth: '236px',
    width: '236px',
    minHeight: 'calc(38px + 32px)',
    flexShrink: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));
